import AllPosts from "./modules/AllPosts/AllPosts";
import Bento from "./modules/Bento/Bento";
import Callout from "./modules/Callout/Callout";
import Chips from "./modules/Chips/Chips";
import Client from "./modules/Client/Client";
import Columns from "./modules/Columns/Columns";
import Comparative from "./modules/Comparative/Comparative";
import ContactForm from "./modules/ContactForm/ContactForm";
import ContactFormImages from "./modules/ContactFormImages/ContactFormImages";
import Descriptive from "./modules/Descriptive/Descriptive";
import RichColumns from "./modules/RichColumns/RichColumns";
import RichContent from "./modules/RichContent/RichContent";
import FAQ from "./modules/FAQ/FAQ";
import GalleryLayout from "./modules/GalleryLayout/GalleryLayout";
import HeroRevamp from "./modules/HeroRevamp/HeroRevamp";
import TitleText from "./modules/TitleText/TitleText";
import Logos from "./modules/Logos/Logos";
import Navigation from "./modules/Navigation/Navigation";
import ProjectHeadline from "./modules/ProjectHeadline/ProjectHeadline";
import Quote from "./modules/Quote/Quote";
import RecentPosts from "./modules/RecentPosts/RecentPosts";
import RelatedArticles from "./modules/RelatedArticles/RelatedArticles";
import SelectedPost from "./modules/SelectedPost/SelectedPost";
import SEO from "./modules/SEO/SEO";
import Services from "./modules/Services/Services";
import TimeZone from "./modules/TimeZone/TimeZone";
// import for new component DO NOT DELETE

/**
 * Shared ACF flexible-content -> component switch, used by Page, SingleCaseStudy,
 * and SingleOpenRoles so the module set can't drift between templates.
 */
const renderModules = (modules = [], meta) => {
  if (!modules) return null;

  return modules.map((x, i) => {
    switch (x.acf_fc_layout) {
      case "AllPosts":
        return <AllPosts key={i} data={x} />;
      case "Bento":
        return <Bento key={i} data={x} />;
      case "Callout":
        return <Callout key={i} data={x} />;
      case "Chips":
        return <Chips key={i} data={x} />;
      case "Client":
        return <Client key={i} data={x} />;
      case "Columns":
        return <Columns key={i} data={x} />;
      case "Comparative":
        return <Comparative key={i} data={x} />;
      case "ContactForm":
        return <ContactForm key={i} data={x} />;
      case "ContactFormImages":
        return <ContactFormImages key={i} data={x} />;
      case "Descriptive":
        return <Descriptive key={i} data={x} />;
      case "FAQ":
        return <FAQ key={i} data={x} />;
      case "GalleryLayout":
        return <GalleryLayout key={i} data={x} />;
      case "HeroRevamp":
        return <HeroRevamp key={i} data={x} />;
      case "TitleText":
        return <TitleText key={i} data={x} />;
      case "Logos":
        return <Logos key={i} data={x} />;
      case "Navigation":
        return <Navigation key={i} data={x} />;
      case "ProjectHeadline":
        return <ProjectHeadline key={i} data={x} meta={meta} />;
      case "Quote":
        return <Quote key={i} data={x} />;
      case "RecentPosts":
        return <RecentPosts key={i} data={x} />;
      case "RelatedArticles":
        return <RelatedArticles key={i} data={x} />;
      case "RichColumns":
        return <RichColumns key={i} data={x} />;
      case "RichContent":
        return <RichContent key={i} data={x} />;
      case "SEO":
        return <SEO key={i} data={x} />;
      case "SelectedPost":
        return <SelectedPost key={i} data={x} />;
      case "Services":
        return <Services key={i} data={x} />;
      case "TimeZone":
        return <TimeZone key={i} data={x} />;
      default:
        return null;
    }
  });
};

export default renderModules;
